import Vue from "vue";

import comboComponent from "@/components/child/form/combo.vue";
import dateTimePickerComponent from "@/components/child/form/datetimepicker.vue";
import decimalComponent from "@/components/child/form/decimal.vue";
import { Component, Prop } from "@/decorators";
import ManipulacaoLoteEstoqueModel from "@/models/manipulacaoLoteEstoqueModel";
import ProdutoLoteModel from "@/models/produtoLoteModel";
import manipulacaoLoteEstoqueService from "@/services/manipulacaoLoteEstoqueService";

@Component({
    components: {
        decimalComponent,
        dateTimePickerComponent,
        comboComponent,
    },
})
export default class ItemComponent extends Vue {
    private isEdit = false;
    private isEditQtdLote = false;

    private loteOptions = [];

    model = new ManipulacaoLoteEstoqueModel();

    @Prop(Object) item: ManipulacaoLoteEstoqueModel;
    @Prop(Number) manipulacaoOrdemId: number;
    @Prop(Array) produtoLoteOptions: ProdutoLoteModel[];
    @Prop({ type: Number, default: 0 }) movimentacaoEstoqueId: number;

    private async load() {
        this.model.updateFrom(this.item);

        try {
            this.loteOptions = this.produtoLoteOptions.filter(
                p =>
                    p.produtoId == this.item.produtoId &&
                    (p.quantidadeAtual > 0 || p["value"] == this.item.produtoLoteId),
            );
        } catch {}
    }

    private async onAlteraLote(produtoLoteId: any) {
        this.model.quantidadeAtual = this.loteOptions.find(p => p["value"] == produtoLoteId)?.quantidadeAtual;
    }

    private async onEditLote() {
        this.isEdit = !this.isEdit;
    }

    private async onEditLoteQuantidade(name: string, model: any) {
        this.isEditQtdLote = !this.isEditQtdLote;
    }

    private async onConfirmar(model: ManipulacaoLoteEstoqueModel) {
        model.produtoLoteDescricao = this.loteOptions.find(p => p["value"] == model.produtoLoteId)?.text;
        model.movimentacaoEstoqueId = this.movimentacaoEstoqueId;
        model.manipulacaoOrdemId = this.manipulacaoOrdemId;

        if (this.isEditQtdLote) {
            const retorno = await manipulacaoLoteEstoqueService.atualizarQuantidadeLote(model);

            this.$notifySuccess(this.$t("__.ts.loteEstoqueAtual"), this.$t("__.ts.lote"));

            this.$emit("onChangeItem", retorno);
        } else {
            const retorno = await manipulacaoLoteEstoqueService.atualizarLote(model);

            this.$notifySuccess(this.$t("__.ts.loteAtualizado"), this.$t("__.ts.lote"));
            this.model.quantidadePesagem = retorno.quantidadePesagem;
            this.$emit("onChangeItem", retorno);
        }

        this.isEditQtdLote = false;
        this.isEdit = false;
    }

    private async mounted() {
        if (this.item) {
            this.load();
        }
    }
}
